import React, {useEffect, useState} from 'react';
import PageHeader from "../components/page-header";
import axios from "axios";
import Span from "../../system/components/span";
import {Tag} from "primereact/tag";
import BoxHeader from "../components/box-header";

function Index(props) {
    const [data, setData] = useState();

    const getUpdateLogs = async () => {
        const { data } = await axios.get(`update-logs.json`);
        return data;
    };

    useEffect(() => {
        (async () => {
            const _data = await getUpdateLogs();

            setData(_data);
        })();
    }, []);


    function sortByDateTime(arr, order = 'desc') {
        return arr.sort((a, b) => {
            const dateA = new Date(a.releasedon);
            const dateB = new Date(b.releasedon);

            return order === 'asc'
                ? dateA - dateB
                : dateB - dateA;
        });
    }

    return (
        <div className="h-full overflow-auto scrollbar-hide">
            <PageHeader title={props.name} description={props.description}/>
            <div className="p-3 flex flex-column gap-3 pb-5">
                <div className="border-round-xl border-300 border-1 p-2 pt-3 surface-card text-700">
                    <BoxHeader title="Next Updates" />
                    {data && data["next-update"].map(e=>(<ul><li><div className="flex align-items-center gap-1"><Span spanClassName="font-bold" type="GREGORIAN_DATE" format="YYYY/MM/DD">{e.releasedon}</Span>{e.version&&<Tag severity="warning" value={`${e.version}`}/>}</div><ul>{e.features&&e.features.map(f=>(<li>{f}</li>))}</ul></li></ul>))}
                </div>
                <div className="surface-card border-round-xl border-1 border-300 p-2 pt-3">
                    <BoxHeader title="Published Updates" />
                    {data && sortByDateTime(data.published).map(e=>(<ul><li><div className="flex align-items-center gap-1"><Span spanClassName="font-bold" type="GREGORIAN_DATE" format="YYYY/MM/DD">{e.releasedon}</Span>{e.version&&<Tag severity="info" value={`${e.version}`}/>}</div><ul>{e.features&&e.features.map(f=>(<li>{f}</li>))}</ul></li></ul>))}
                </div>
            </div>
        </div>
    );
}

export default Index;